import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const Parcel5Kg: FC<SvgIconProps> = ({ viewBox = '0 0 255 170', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M105.864 80.601L206.833 62.48 149.136 34 48.166 51.753 105.865 80.6z" fill="#FDDE84" />
    <path opacity=".4" d="M81.084 68.026l100.969-17.753-9.616-4.808-101.34 18.123 9.987 4.438z" fill="#AA7B33" />
    <path d="M105.864 80.601v53.259l-57.697-28.848v-53.26l57.697 28.85z" fill="#C39000" />
    <path opacity=".4" d="M81.084 68.026v19.972l-9.987-5.178V63.588l9.987 4.438z" fill="#AA7B33" />
    <path d="M105.864 80.601v53.259l100.969-18.493V62.478L105.864 80.602z" fill="#FCCE09" />
    <path
      d="M226.7 85.6c0-3.2-7.8-5.8-17.3-5.8s-17.3 2.6-17.3 5.8V122c0 3.2 7.8 5.8 17.3 5.8s17.3-2.7 17.3-5.8V85.6z"
      fill="#6D6D6D"
    />
    <path
      d="M226.7 122V85.6c0 1.4-1.5 2.8-4.2 3.8v36.4c2.7-1 4.2-2.4 4.2-3.8zM209.3 91.4c-9.6 0-17.3-2.7-17.3-5.8V122c0 3.2 7.8 5.8 17.3 5.8h2.8V91.5c-.8-.1-1.8-.1-2.8-.1z"
      fill="#6D6D6D"
    />
    <path
      d="M209.3 91.4c9.555 0 17.3-2.597 17.3-5.8s-7.745-5.8-17.3-5.8-17.3 2.597-17.3 5.8 7.745 5.8 17.3 5.8z"
      fill="#C8C8C8"
    />
    <path
      opacity=".05"
      d="M209.4 88.3c5.302 0 9.6-1.433 9.6-3.2 0-1.767-4.298-3.2-9.6-3.2s-9.6 1.433-9.6 3.2c0 1.767 4.298 3.2 9.6 3.2z"
      fill="#000"
    />
    <path
      d="M212.2 85.3v-5.9c0-.5-1.3-.9-2.8-.9-1.5 0-2.8.4-2.8.9v5.8c0 .1.1.3.3.4.4.4 1.4.6 2.5.6.9 0 1.6-.1 2.1-.4.1 0 .1 0 .3-.1h.1s.1 0 .1-.1l.1-.1c.1 0 .1 0 .1-.2z"
      fill="#555"
    />
    <path
      d="M219 73.2c0-1.8-4.3-3.2-9.6-3.2s-9.6 1.4-9.6 3.2v5.4c0 1.8 4.3 3.2 9.6 3.2s9.6-1.4 9.6-3.2v-5.4z"
      fill="#6D6D6D"
    />
    <path
      opacity=".1"
      d="M219 73.2c0-1.8-4.3-3.2-9.6-3.2s-9.6 1.4-9.6 3.2v5.4c0 1.8 4.3 3.2 9.6 3.2s9.6-1.4 9.6-3.2v-5.4z"
      fill="#fff"
    />
    <path
      d="M219 78.6v-5.4c0 .8-.9 1.5-2.3 2v5.4c1.4-.5 2.3-1.1 2.3-2zM209.4 76.4c-5.3 0-9.6-1.4-9.6-3.2v5.4c0 1.8 4.3 3.2 9.6 3.2h1.5v-5.4h-1.5z"
      fill="#6D6D6D"
    />
    <path
      d="M209.4 76.4c5.302 0 9.6-1.433 9.6-3.2 0-1.767-4.298-3.2-9.6-3.2s-9.6 1.433-9.6 3.2c0 1.767 4.298 3.2 9.6 3.2z"
      fill="#C8C8C8"
    />
    <path
      d="M212.7 109.8c-2 .1-3.6-.4-4.8-1.3.6-1 .9-1.5 1.5-2.4.4.2.9.4 1.4.6.5.2 1.2.2 1.8.2.6 0 1.1-.2 1.4-.4.3-.2.5-.6.5-1.1 0-.5-.2-.8-.5-1-.3-.2-.9-.3-1.7-.3H209v-7.2c3.5.2 5.5.2 8.5-.7v2.7c-1.8.5-2.9.6-5 .7v1.8c.5 0 .8 0 1.4-.1.8-.1 1.6 0 2.2.1.6.1 1.1.5 1.5.9.4.5.5 1.2.5 2 0 1-.2 1.9-.6 2.6-.4.8-1 1.4-1.9 1.9-.8.7-1.7 1-2.9 1zM206.4 120.8v-7.6c.9.1 1.3.1 2.2.2v2.9h.5c.7-1.1 1.1-1.7 1.8-2.9 1.1 0 1.6 0 2.7-.1-1 1.6-1.5 2.3-2.5 3.8 1.1 1.5 1.6 2.3 2.7 3.7-1.1.1-1.7.1-2.8.1-.8-1.2-1.2-1.8-1.9-3h-.4v3c-1 0-1.5 0-2.3-.1zM217.4 120.5c-1 .3-1.9.1-2.5-.5-.6-.6-.9-1.4-.9-2.6v-.6c0-.8.2-1.4.5-2 .3-.6.7-1 1.3-1.4.5-.4 1.1-.6 1.8-.8 1.1-.3 1.8-.3 2.3.2-.4.7-.6 1-1 1.7-.2-.2-.3-.2-.5-.3-.2 0-.4 0-.7.1-.4.1-.8.3-1 .7-.2.4-.3.9-.3 1.6v.5c0 .7.1 1.2.3 1.4.2.3.5.4.9.3.4-.1.6-.3.8-.6.2-.3.3-.6.3-1-.5.2-.7.2-1.2.3v-1.6c1.3-.3 1.9-.5 2.9-1.1v1.4c0 1-.2 2-.7 2.8-.7.7-1.4 1.3-2.3 1.5z"
      fill="#D3D1D1"
    />
    <path
      opacity=".2"
      d="M222.6 125.8s0-.1 0 0V89.4c-2.7 1.1-6.1 1.8-10.5 2v36.3c4.5-.1 7.8-.8 10.5-1.9z"
      fill="#fff"
    />
  </SvgIcon>
)
